<template>
  <div class="success-box pr" @touchmove.prevent>
    <input type="text" :value="yycode" class="inputbox pa" />
    <p
      class="inquire btn"
      @click="googleShop(pageInfo.appleStoreUrl)"
      v-if="shop == 'ios'"
    >
      <img src="../assets/images/page2/iosbtn2.png" alt="" />
    </p>

    <p class="inquire btn" @click="googleShop(pageInfo.googleStoreUrl)" v-else>
      <img src="../assets/images/page2/googlebtn2.png" alt="" />
    </p>
  </div>
</template>

<script>
import { shopSubscribe } from "@/js/api.js";
export default {
  name: "SuccessgBox",
  props: ["pageInfo"],
  data() {
    return {
      shop: "",
      yycode: "",
      backNum: this.$util.getItem("backShowNum") || 0,
    };
  },
  created() {
    this.shop = this.$util.appSource();
    this.yycode = this.$util.getItem("dxzPhone").giftCode;
  },
  mounted() {
    this.$bus.$on("num2", (res) => {
      this.backNum = res;
    });
  },
  methods: {
    googleShop(value) {
      let data = this.$util.getToken().token;
      shopSubscribe(data).then((res) => {
        console.log(res);
        this.$xmlog.clickStore(() => {
          location.href = value;
          this.$util.setItem("backShow", true);
          this.$util.setItem("backShowNum", this.backNum + 1);
          this.$bus.$emit("num", this.backNum + 1);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.success-box {
  font-family: medium;
  width: 100%;
  height: 100%;
  .inputbox {
    width: 2.7rem;
    right: 0.1rem;
    top: 0.5rem;
    padding: 0.15rem 0.2rem;
    color: #000612;
    background: url("../assets/images/inputbg.png");
    background-size: 100% 100%;
    border: none;
    text-align: left;
    font-weight: bold;
    font-size: 0.32rem;
  }
  .inquire {
    width: 2.5rem;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 48%;
    // transform: translateX(-40%);
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
}
</style>
